import { render, staticRenderFns } from "./AlgoliaSearch.vue?vue&type=template&id=4abb6e1a&scoped=true&"
import script from "./AlgoliaSearch.vue?vue&type=script&lang=js&"
export * from "./AlgoliaSearch.vue?vue&type=script&lang=js&"
import style0 from "./AlgoliaSearch.vue?vue&type=style&index=0&id=4abb6e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abb6e1a",
  null
  
)

export default component.exports